import { Suspense } from "react";

import { LoadingPage } from "@hl/base-components/lib/LoadingPage";
import AlertProvider from "@hl/base-components/lib/alert/AlertProvider";
import { AuthProvider } from "@hl/shared-features/lib/features/auth";
import { AppBootstrap } from "@hl/shared-features/lib/features/auth/AppBootstrap";
import TransactionProvider from "@hl/shared-features/lib/features/evm-tx/TransactionProvider";
import { NotFound } from "@hl/shared-features/lib/features/layout/NotFound";
import MarketplaceProvider from "@hl/shared-features/lib/features/marketplace/provider";
import { ModalStack } from "@hl/shared-features/lib/features/modal";
import { WatchlistAndFollowContextProvider } from "@hl/shared-features/lib/features/watchlist-and-follow/WatchlistAndFollowContext";
import { Route, Routes } from "react-router-dom";

import { USER_URL } from "~config";

import Root from "./features/layout/Root";
import { MyProfile } from "./features/profile/MyProfile";
import { UserProfile } from "./features/profile/UserProfile";
import { AccountSettings } from "./features/profile/settings/AccountSettings";

export const App = () => {
  const userPath = USER_URL.user.profile.replace("@", "") + "/:view?";
  const userEditPath =
    USER_URL.user.accountSettings.default.replace("@", "") + "/:view?";

  return (
    <Suspense fallback={""}>
      <AuthProvider>
        <AppBootstrap>
          <AlertProvider>
            <TransactionProvider>
              <MarketplaceProvider>
                <WatchlistAndFollowContextProvider>
                  <ModalStack>
                    <Root>
                      <Routes>
                        <Route path={"*"} element={<LoadingPage />} />
                        <Route
                          // React router dropped support for special characters, but we don't want to break the current link system, so we're stripping the "@" character from URL param inside component
                          // https://github.com/remix-run/react-router/releases/tag/react-router%406.5.0
                          path={userPath}
                          element={<UserProfile />}
                        />
                        <Route
                          path={userEditPath}
                          element={<AccountSettings />}
                        />
                        <Route
                          path={USER_URL.user.myProfile}
                          element={<MyProfile />}
                        />
                        <Route path={"*"} element={<NotFound />} />
                      </Routes>
                    </Root>
                  </ModalStack>
                </WatchlistAndFollowContextProvider>
              </MarketplaceProvider>
            </TransactionProvider>
          </AlertProvider>
        </AppBootstrap>
      </AuthProvider>
    </Suspense>
  );
};
